import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromShippingPrices from './reducers';
import { ShippingInfo } from '@app/models/prices';

export const selectShippingPricesState = createFeatureSelector<fromShippingPrices.State>(fromShippingPrices.featureKey);

export const selectIsLoading = createSelector(selectShippingPricesState, state => state.loading);

export const selectIsLoaded = createSelector(selectShippingPricesState, state => state.loaded);

export const selectShippingPrices = createSelector(selectShippingPricesState, state => state.data);

export const selectShippingZones = createSelector(selectShippingPrices, shippingPrices => shippingPrices?.zones ?? []);

export const selectShippingCountries = createSelector(selectShippingPrices, shippingPrices => shippingPrices?.countries ?? []);

export const selectShippingPackageSizes = createSelector(selectShippingPrices, shippingPrices => shippingPrices?.packageSizes ?? []);

// export const selectShippingMutuallyExclusiveExtraServices = createSelector(
// 	selectShippingPrices,
// 	shippingPrices => shippingPrices?.extraServices.mutuallyExclusiveServices ?? []
// );

export const selectShippingExtraServiceGroups = createSelector(selectShippingPrices, shippingPrices => shippingPrices?.extraServices.groups ?? []);

export const selectShippingExtraServices = createSelector(selectShippingPrices, shippingPrices => shippingPrices?.extraServices.services ?? []);

export const selectShippingDataProp = <P extends keyof ShippingInfo>(prop: P) => createSelector(selectShippingPrices, shippingPrices => shippingPrices?.[prop]);
